import { Pipe, PipeTransform } from '@angular/core';
import { AppointmentRequestObjectType } from '@warema/shared/models';

@Pipe({
    name: 'appointmentObjectTypePipe',
})
export class AppointmentObjectTypePipe implements PipeTransform {
    public transform(objectType: AppointmentRequestObjectType): string {
        switch (objectType) {
            case AppointmentRequestObjectType.ApartmentOwner:
                return 'APARTMENT_OWNER';

            case AppointmentRequestObjectType.ApartmentRent:
                return 'APARTMENT_RENT';

            case AppointmentRequestObjectType.House:
                return 'HOUSE';

            default:
                return 'UNKNOWN';
        }
    }
}
